import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export type StripeCredentialBannerReason =
  | 'test_mode'
  | 'key_mode_mismatch'
  | 'missing_keys';

export interface StripeCredentialEnvironmentDto {
  showBanner: boolean;
  reason: StripeCredentialBannerReason | null;
}

export const getStripeCredentialEnvironmentAPI =
  async (): Promise<StripeCredentialEnvironmentDto> => {
    const response = await baseAPI.get<StripeCredentialEnvironmentDto>(
      '/payment-processor/credential/stripe-environment',
    );
    return response.data;
  };

export const useGetStripeCredentialEnvironment = (
  options?: Omit<
    UseQueryOptions<StripeCredentialEnvironmentDto>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery({
    queryKey: [KEYS.STRIPE_CREDENTIAL_ENVIRONMENT],
    queryFn: () => getStripeCredentialEnvironmentAPI(),
    ...options,
  });
};
